<script setup>

import {Tab} from "@/base-components/Headless";
import {useUserStore} from "@/stores/user.js";
import {onMounted, ref} from "vue";
import ProfileCard from "@/pages/account/components/ProfileCard.vue";
import {useFetch} from "@/composables/useFetch.js";
import {uri} from "@/constants/config.js";
import ProfileEditCard from "@/pages/account/components/ProfileEditCard.vue";
import PasswordCard from "@/pages/account/components/PasswordCard.vue";

const profile = ref({});
const isLoading = ref(true)


async function fetchData() {
  isLoading.value = true
  const res = await useFetch(uri.api.user.profile.onboarding)
  profile.value = res.data
  isLoading.value =false
}

onMounted(() => fetchData())
</script>

<template>
  <Tab.Group>
    <ProfileCard :is-loading="isLoading" :profile="profile"/>
    <free-style-shimmer height="500px" width="100%" class="rounded-2xl m-10" v-if="isLoading"/>
    <div class="min-h-[57vh] box p-4">
      <div class="border-1 border-gray-200 w-full">
        <Tab.Panels v-if="!isLoading">
          <Tab.Panel>
            <ProfileEditCard :profile="profile" v-if="!isLoading" @update="fetchData"/>
          </Tab.Panel>
          <Tab.Panel>
            <PasswordCard :profile="profile" v-if="!isLoading"/>
          </Tab.Panel>
        </Tab.Panels>
      </div>
    </div>
  </Tab.Group>
</template>

<style scoped>

</style>